import type { ChangeEvent } from "react";

import { InputErrorMessage } from "@/components/base/input/input-error-message";
import { InputRadio } from "@/components/base/input/input-radio";
import { FlexFlowContainer } from "@/components/layout/flex-flow-container";
import { HorizontalSpacer } from "@/components/layout/horizontal-spacer";
import { VerticalContainer } from "@/components/layout/vertical-container";
import { VerticalSpacer } from "@/components/layout/vertical-spacer";

interface GenderInputProps {
  externalErrorMessage?: string;
  checkedAll: boolean;
  checkedFemale: boolean;
  checkedMale: boolean;
  idAll?: string;
  idFemale?: string;
  idMale?: string;
  name?: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const GenderInput = ({
  externalErrorMessage,
  checkedAll,
  checkedFemale,
  checkedMale,
  idAll,
  idFemale,
  idMale,
  name,
  onChange,
}: GenderInputProps) => (
  <VerticalContainer>
    <FlexFlowContainer>
      <VerticalContainer>
        <InputRadio
          checked={checkedFemale}
          id={idFemale ?? "gender-female"}
          label="Kvinne"
          onChange={onChange}
          name={name ?? "Kjønn"}
          value="kvinne"
        />
        <HorizontalSpacer size="x-small" />
      </VerticalContainer>

      <VerticalSpacer size="medium" />

      <VerticalContainer>
        <InputRadio
          checked={checkedMale}
          id={idMale ?? "gender-male"}
          label="Mann"
          onChange={onChange}
          name={name ?? "Kjønn"}
          value="mann"
        />
        <HorizontalSpacer size="x-small" />
      </VerticalContainer>

      <VerticalSpacer size="medium" />

      <VerticalContainer>
        <InputRadio
          checked={checkedAll}
          id={idAll ?? "gender-all"}
          label="Annet / Ønsker ikke å oppgi"
          onChange={onChange}
          name={name ?? "Kjønn"}
          value="ønsker ikke å oppgi"
        />
        <HorizontalSpacer size="x-small" />
      </VerticalContainer>
    </FlexFlowContainer>
    <InputErrorMessage externalErrorMessage={externalErrorMessage} />
  </VerticalContainer>
);
